import { getReportHeaders } from "@adapters/infrastructures/urlConfig/Reports/reportHeaders";
import urlConfig from "@adapters/infrastructures/urlConfig/Reports/reportsUrl";
import { ApproximateTxnsMapper } from "@domains/mapper/Reports/TransactionHistory/ApproximateTxns";
import { TransactionHistoryMapper } from "@domains/mapper/Reports/TransactionHistory/TransactionHistory";
import { getIsInIFrame } from "@domains/utils/tokenParser";
class TransactionHistoryRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getTransactionReport(req) {
        var _a;
        let url = new URL(urlConfig.transaction);
        const accountCode = await this.accountDetails.getAccountCode();
        url.searchParams.append("accountId", accountCode);
        url.searchParams.append("fromDate", req.fromDate);
        url.searchParams.append("toDate", req.toDate);
        url.searchParams.append("pageSize", req.pageSize.toString());
        url.searchParams.append("pageNumber", req.pageNumber.toString());
        if (req.scripIdentifier)
            url.searchParams.append("scripIdentifier", req.scripIdentifier.toString());
        url.searchParams.append("assetType", (_a = req === null || req === void 0 ? void 0 : req.assetType) === null || _a === void 0 ? void 0 : _a.toString());
        if (req.isPage)
            url.searchParams.append("isPage", req.isPage.toString());
        let resp = await this.http.makeApiCall({
            method: "GET",
            headers: getReportHeaders(accountCode),
            url: url.toString(),
        });
        return TransactionHistoryMapper(resp.data, req.pageSize);
    }
    async getApproximateTransactions(req) {
        let url = new URL(urlConfig.transaction + "/base");
        const accountCode = await this.accountDetails.getAccountCode();
        url.searchParams.append("accountId", accountCode);
        req.transactionIds.forEach((x) => {
            url.searchParams.append("transactionId", x.toString());
        });
        let resp = await this.http.makeApiCall({
            method: "GET",
            headers: getReportHeaders(accountCode),
            url: url.toString(),
            avoidAuthToken: getIsInIFrame(),
        });
        return ApproximateTxnsMapper(resp);
    }
}
export default TransactionHistoryRepository;
